<div class="container">
  <mat-card>
    <form [formGroup]="codeForm" (ngSubmit)="submit()">
      <mat-card-content>
        <div class="layout-column">
          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Code Name' | translate }}</mat-label>
            <input matInput required formControlName="name" />
            @if (codeForm.controls.name.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Code Name' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>
        </div>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button
          mat-raised-button
          color="primary"
          [disabled]="!codeForm.valid || codeForm.pristine"
          *LOSxHasPermission="'UPDATE_CODE'"
        >
          {{ 'labels.buttons.Submit' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
